import styled from 'styled-components';

export const BreadcrumbWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: max-content;
  gap: 4px;
  max-width: 348px;

  @media (max-width: 1440px) {
    max-width: 228px;
  }
`;

export const BreadcrumbElement = styled.div<{ $hasMinLength?: boolean }>`
  overflow: hidden;
  flex-grow: ${({ $hasMinLength }) => ($hasMinLength ? 0 : 1)};
  flex-shrink: ${({ $hasMinLength }) => ($hasMinLength ? 0 : 1)};
  white-space: nowrap;

  span {
    height: 20px;
    line-height: 20px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    ${({ theme: { font } }) => font.t3};
    cursor: pointer;
  }
`;

export const ChevronContainer = styled.div`
  overflow: hidden;
  width: 6px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
